import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Components
import Hero from '../Stonk-Components/Stonk-Hero';

function AboutPage(props) {

    const left_label = {
        marginTop: '10px'
    };

    const left_label_ = {
        marginTop: '10px'
    };

    const top_border = {
        borderTop: "1px solid black"
    };

    return (
        <div>
            <Hero title={'Welcome to Stonk!'} subTitle={'Privacy Policy'} location="a" />

            <Container fluid={true} className="About-Me-Page-Container">
                <Row className="justify-content-left">
                    
                    <p className="pl-5 pr-5 ">At Stonk, accessible from Apple App Store iOS, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Stonk and how we use it.</p>
                    <p className="pl-5 pr-5 ">If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.</p>
                    <p className="pl-5 pr-5 ">This Privacy Policy applies only to our online activities and is valid for visitors to our application with regards to the information that they shared and/or collect in Stonk. This policy is not applicable to any information collected offline or via channels other than this application.</p>
                </Row>

                <Row className="justify-content-left">
                    <h2 className="pl-5 pr-5 text-left" style={left_label_} style={{color: 'White'}}>Consent:</h2>
                 
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">By using our application, you hereby consent to our Privacy Policy and agree to its terms.</p>
                </Row>

                <Row className="justify-content-left">
                    <h2 className="pl-5 pr-5 text-left" style={left_label} style={{color: 'White'}}>Information we collect:</h2>
                </Row>

                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.</p>
                </Row>

                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.</p>
                </Row>
    
                <Row className="justify-content-left">
                    <h2 className="pl-5 pr-5 text-left" style={left_label} style={{color: 'White'}}>How we use your information: </h2>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">We use the information we collect in various ways, including to:</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• Provide, operate, and maintain our application</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• Improve, personalize, and expand our application</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• Understand and analyze how you use our application</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• Develop new products, services, features, and functionality</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the application, and for marketing and promotional purposes</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• Send you emails & updates</p>
                </Row>

                <Row className="justify-content-left">
                    <h2 className="pl-5 pr-5 text-left" style={left_label} style={{color: 'White'}}>CCPA Privacy Rights: </h2>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">Under the CCPA, among other rights, California consumers have the right to:</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• Request that a business delete any personal data about the consumer that a business has collected.</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• Request that a business that sells a consumer's personal data, not sell the consumer's personal data.</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.</p>
                </Row>
                
                <Row className="justify-content-left">
                    <h2 className="pl-5 pr-5 text-left" style={left_label} style={{color: 'White'}}>GDPR Data Protection Rights: </h2>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• The right to access – You have the right to request copies of your personal data. We may charge you a small fee for this service.</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• The right to rectification – You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• The right to erasure – You have the right to request that we erase your personal data, under certain conditions.</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• The right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions.</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• The right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.</p>
                </Row>
                <Row className="justify-content-left">
                    <p className="pl-5 pr-5 ">• If you make a request, we have two months to respond to you. If you would like to exercise any of these rights, please contact us.</p>
                </Row>

            </Container>

        </div>
    );
}

export default AboutPage;